export default {
    lang: {
        name: 'Firstname'
    }
}